import axios from 'axios'
export const baseURL = 'https://estoque.danyllo106.com'
// export const baseURL = 'https://estoquecaminhao.danyllo106.com';
export const api = axios.create({
  baseURL
})
